// extracted by mini-css-extract-plugin
export default {"comment":"commentItem_comment__R3Yxn"};